import { Eye, Presentation, Hand, Compass } from "lucide-react";
import { Reveal, ChapterLabel } from "./Reveal";
import { TEACHER_BENEFITS } from "@/data";

const ICONS = [Eye, Presentation, Hand, Compass];

export default function ForTeachers() {
  return (
    <section id="teachers" data-testid="teachers-section" className="relative py-16 sm:py-24">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div>
            <ChapterLabel number="06" label="For Teachers" />
            <Reveal delay={0.1}>
              <h2
                data-testid="teachers-heading"
                className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-tight text-[#FFFDF9]"
              >
                For teachers.
                <br />
                Explain with more{" "}
                <span className="italic text-[#38BDF8]">possibilities</span>.
              </h2>
            </Reveal>

            <div className="mt-10 space-y-7">
              {TEACHER_BENEFITS.map((b, i) => {
                const Icon = ICONS[i];
                return (
                  <Reveal key={b.title} delay={0.08 + i * 0.06}>
                    <div data-testid={`teacher-benefit-${b.title.toLowerCase()}`} className="flex gap-5 group">
                      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#38BDF8]/25 text-[#38BDF8] transition-colors duration-500 group-hover:bg-[#38BDF8]/10">
                        <Icon size={17} strokeWidth={1.6} />
                      </div>
                      <div>
                        <h3 className="font-display text-lg text-[#FFFDF9]">{b.title}</h3>
                        <p className="mt-1 max-w-sm text-sm text-slate-400 leading-relaxed">{b.desc}</p>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>

            <Reveal delay={0.35}>
              <p data-testid="teachers-subjects" className="mt-10 text-[10px] tracking-[0.3em] uppercase text-slate-400">
                Biology <span className="text-[#38BDF8] mx-1">·</span> Physics{" "}
                <span className="text-[#38BDF8] mx-1">·</span> Mathematics{" "}
                <span className="text-[#38BDF8] mx-1">·</span> Geography{" "}
                <span className="text-[#38BDF8] mx-1">·</span> History
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.2}>
            <div className="relative overflow-hidden rounded-2xl border border-white/[0.08]">
              <img
                src="/images/teachers.jpg"
                alt="A teacher wearing AuraXR teacher glasses guiding a 3D heart visualization in a bright classroom"
                loading="lazy"
                className="aspect-[4/5] sm:aspect-[16/13] w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050811]/60 via-transparent to-transparent" />
              <p className="absolute bottom-5 left-5 text-[10px] tracking-[0.3em] uppercase text-slate-200/90">
                Concept experience — envisioned classroom
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
